<template>
  <div class="card_ventas">
    <div class="grey_background">
      <div class="card_header">
        <div class="header_left">
          <span class="period_text">{{ period }}</span>
        </div>
        <div class="header_right">
          <span v-if="mom" class="pill pill_green">{{ mom }} MoM</span>
          <span v-if="yoy" class="pill pill_light_green">{{ yoy }} YoY</span>
        </div>
      </div>

      <div class="main_amount mt-2">
        {{ formatMoney(amount) }}
      </div>
    </div>

    <div class="bottom_section mt-2">
      <ProgressBarSection :items="progressItems" />
    </div>
  </div>
</template>

<script>
import { parseToMoney } from "@/utils/currency";
import ProgressBarSection from "./ProgressBarSection.vue";

export default {
  name: 'CardVentas',
  components: {
    ProgressBarSection
  },
  props: {
    period: String,
    amount: Number,
    mom: String,
    yoy: String,
    progressItems: Array
  },
  methods: {
    formatMoney(val) {
      return parseToMoney(val);
    }
  }
}
</script>

<style scoped lang="scss">
.card_ventas {
  padding: 12px 12px 5px 12px;
  background: #FFF;
  border-radius: 16px;
  border: 1px solid #EBEBEB;
  flex: 1;
  min-width: 320px;
  box-shadow: 0 1px 2px 0 rgba(10, 13, 20, 0.03);
}

.grey_background {
  padding: 16px 12px;
  background: #EAECF0;
  border-radius: 16px;
  border: 1px solid #EBEBEB;
}

.card_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.period_text {
  color: #5C5C5C;
  font-size: 14px;
  font-weight: 500;
}

.pill {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  margin-left: 4px;
}

.pill_green {
  background: #EDFDFE;
  color: #157389;
  border: 1px solid #AAF1F7;
}

.pill_light_green {
  background: #EDFDFE;
  color: #157389;
  border: 1px solid #AAF1F7;
}

.main_amount {
  font-size: 32px;
  font-weight: 500;
  color: #171717;
  letter-spacing: -0.16px;
}

.bottom_section {
  padding: 0 4px;
}
</style>
